// アコーディオンのトグル機能
function toggleAccordion(element) {
  const content = element.nextElementSibling;
  const isOpen = content.classList.contains("is-open");

  // 現在のアコーディオンの開閉のみ
  if (isOpen) {
    content.classList.remove("is-open");
    element.classList.remove("is-active");
  } else {
    // クリックされたアコーディオンのみを開く
    content.classList.add("is-open");
    element.classList.add("is-active");
  }
}

// アコーディオンのborder-bottomを設定する関数
function setAccordionBorders() {
  const accordions = document.querySelectorAll(".c-acordion");

  if (accordions.length === 0) return;

  // すべてのアコーディオンからクラスを削除
  accordions.forEach((accordion) => {
    accordion.classList.remove("c-acordion--last-child");
  });

  if (accordions.length === 1) {
    // 1つだけの場合
    accordions[0].classList.add("c-acordion--last-child");
  } else {
    // 2つ以上ある場合、最後のアコーディオンのみにクラスを付与
    accordions[accordions.length - 1].classList.add("c-acordion--last-child");
  }
}

// ===================== GSAP Map Tabs Animation =====================
function initMapTabsWithGSAP(root = document) {
  const container = root.querySelector(".c-map__container");
  if (!container || container.dataset.mapInited === "1") return;
  container.dataset.mapInited = "1";

  const tabs = container.querySelectorAll(".c-map__tab");
  const regionTabs = container.querySelectorAll(".c-map__region-tab");
  const contents = container.querySelectorAll(".c-map__tab-content");

  // 現在アクティブ
  let current = container.querySelector(".c-map__tab-content--active");
  let isAnimating = false; // アニメーション中の連打防止

  // 全国マップへ戻るボタンの表示制御
  const backToFirstButton = container.querySelector('.c-map__tab[data-target="first"]');

  // 初期状態の設定
  if (current && current.dataset.content === "first") {
    gsap.set(backToFirstButton, { opacity: 0, visibility: "hidden", display: "none" });
  } else {
    gsap.set(backToFirstButton, { opacity: 1, visibility: "visible", display: "inline-block" });
  }

  if (current) {
    // 初期表示時にもスタイルをリセット
    gsap.set(current, {
      scale: 1,
      opacity: 1,
    });
  }

  // 念のため空hrefの遷移抑止
  container.querySelectorAll('a.c-map__button[href=""], a.c-map__button[href="#"]').forEach((a) => {
    a.addEventListener("click", (e) => e.preventDefault());
  });

  // メインタブ（全国マップへ戻る）クリック
  tabs.forEach((tab) => {
    tab.addEventListener("click", (e) => {
      e.preventDefault();
      if (isAnimating) return;

      const targetKey = tab.dataset.target;
      const target = container.querySelector(`[data-content="${targetKey}"]`);
      if (!target || target === current) return;

      // タブの見た目更新
      tabs.forEach((t) => t.classList.remove("c-map__tab--active"));
      tab.classList.add("c-map__tab--active");

      // GSAPアニメーション開始
      isAnimating = true;

      // 切替パターン判定
      const isSecondToFirst = current.dataset.content !== "first" && target.dataset.content === "first";

      // アニメーション設定
      const animationConfig = {
        duration: 0.5,
        ease: "back.out(1.1)",
      };

      if (isSecondToFirst) {
        // 地方→全国: 縮小しながらfade（1.0→0.9, 1→0）
        // ボタンのfadeアニメーションを即座に開始
        gsap.to(backToFirstButton, {
          opacity: 0,
          visibility: "hidden",
          duration: 0.3,
          ease: "power2.out",
        });

        gsap.to(current, {
          scale: 0.9,
          opacity: 0,
          ...animationConfig,
          onComplete: () => {
            switchContent();
          },
        });
      } else {
        // その他の場合
        switchContent();
      }

      function switchContent() {
        // 現在のを非表示化
        current.classList.remove("c-map__tab-content--active");

        // 対象を表示（ここではアニメーションを適用しない）
        target.classList.add("c-map__tab-content--active");

        // 重要: 新しく表示されるコンテンツのスタイルをリセット
        gsap.set(target, {
          scale: 1,
          opacity: 1,
        });

        // 新しく表示されるコンテンツに美しい登場アニメーション
        gsap.fromTo(
          target,
          {
            scale: 0.9,
            opacity: 0.8,
          },
          {
            scale: 1,
            opacity: 1,
            duration: 0.4,
            ease: "back.out(1.1)",
          }
        );

        // 次回のためにcurrentを更新
        current = target;

        // 全国マップへ戻るボタンの表示制御を更新
        if (current.dataset.content === "first") {
          // 地方→全国の場合は既にボタンのfadeアニメーションが開始されているのでスキップ
          if (!isSecondToFirst) {
            gsap.to(backToFirstButton, {
              opacity: 0,
              visibility: "hidden",
              display: "none",
              duration: 0.3,
              ease: "power2.out",
            });
          }
        } else {
          gsap.to(backToFirstButton, {
            opacity: 1,
            visibility: "visible",
            display: "inline-block",
            duration: 0.3,
            ease: "power2.out",
          });
        }

        isAnimating = false;
      }
    });
  });

  // 地方別タブクリック
  regionTabs.forEach((tab) => {
    tab.addEventListener("click", (e) => {
      e.preventDefault();
      if (isAnimating) return;

      const targetKey = tab.dataset.target;
      const target = container.querySelector(`[data-content="${targetKey}"]`);
      if (!target || target === current) return;

      // メインタブの見た目更新（全国マップへ戻るを非アクティブに）
      tabs.forEach((t) => t.classList.remove("c-map__tab--active"));

      // GSAPアニメーション開始
      isAnimating = true;

      // 切替パターン判定
      const isFirstToSecond = current.dataset.content === "first" && target.dataset.content !== "first";

      // アニメーション設定
      const animationConfig = {
        duration: 0.5,
        ease: "back.out(1.1)",
      };

      if (isFirstToSecond) {
        // 全国→地方: 拡大しながらfade（1.0→1.1, 1→0）
        gsap.to(current, {
          scale: 1.1,
          opacity: 0,
          ...animationConfig,
          onComplete: () => {
            switchContent();
          },
        });
      } else {
        // 地方→別の地方: 縮小しながらfade（1.0→0.9, 1→0）
        gsap.to(current, {
          scale: 0.9,
          opacity: 0,
          ...animationConfig,
          onComplete: () => {
            switchContent();
          },
        });
      }

      function switchContent() {
        // 現在のを非表示化
        current.classList.remove("c-map__tab-content--active");

        // 対象を表示（ここではアニメーションを適用しない）
        target.classList.add("c-map__tab-content--active");

        // 重要: 新しく表示されるコンテンツのスタイルをリセット
        gsap.set(target, {
          scale: 1,
          opacity: 1,
        });

        // 新しく表示されるコンテンツに美しい登場アニメーション
        gsap.fromTo(
          target,
          {
            scale: 0.9,
            opacity: 0.8,
          },
          {
            scale: 1,
            opacity: 1,
            duration: 0.4,
            ease: "back.out(1.1)",
          }
        );

        // 次回のためにcurrentを更新
        current = target;

        // 全国マップへ戻るボタンの表示制御を更新
        if (current.dataset.content === "first") {
          gsap.to(backToFirstButton, {
            opacity: 0,
            visibility: "hidden",
            display: "none",
          });
        } else {
          gsap.to(backToFirstButton, {
            opacity: 1,
            visibility: "visible",
            display: "inline-block",
            duration: 0.3,
            ease: "power2.out",
          });
        }

        isAnimating = false;
      }
    });
  });
}

// ハンバーガーメニュー内のリンククリック時にメニューを閉じる処理
function initMenuDrawerCloseHandler() {
  // メニュー内のすべてのリンクを取得
  const menuLinks = document.querySelectorAll(".menu-drawer__menu-item");
  menuLinks.forEach((link) => {
    link.addEventListener("click", () => {
      // メニューを閉じる処理
      const menuContainer = document.querySelector("#Details-menu-drawer-container");
      const menuIcon = document.querySelector("#Details-menu-drawer-container .header__icon");

      if (menuContainer) {
        menuContainer.click();
      }
      if (menuIcon) {
        menuIcon.click();
      }
    });
  });
}

// custom - 追加改修
// 変更内容：バリアント変更時の在庫数表示更新関数を追加
// 仕様：
//   - 選択されたバリアントの在庫数が1〜9個の場合のみ表示
//   - 0個以下（受注生産）または10個以上の場合は非表示
//   - サイズオプションの下に「残り在庫数：○個」と表示
const __variantInventoryCacheByFormId = new Map();

function __escapeAttributeValue(value) {
  // attribute selector用の最小限のエスケープ（" と \ を潰す）
  return String(value).replace(/\\/g, "\\\\").replace(/"/g, '\\"');
}

function __getVariantInventoryMap(formId) {
  if (!formId) return null;
  if (__variantInventoryCacheByFormId.has(formId)) {
    return __variantInventoryCacheByFormId.get(formId);
  }

  const formIdEscaped = __escapeAttributeValue(formId);
  const picker = document.querySelector(`variant-picker[form-id="${formIdEscaped}"]`);
  const script = picker?.querySelector("script[data-variant-inventory]");
  if (!script) {
    __variantInventoryCacheByFormId.set(formId, null);
    return null;
  }

  try {
    const arr = JSON.parse(script.textContent || "[]");
    const map = new Map();
    if (Array.isArray(arr)) {
      arr.forEach((row) => {
        if (!row) return;
        const id = row.id != null ? String(row.id) : null;
        if (!id) return;
        const qtyRaw = row.inventory_quantity;
        const qty = qtyRaw != null && qtyRaw !== "" ? parseInt(qtyRaw, 10) : null;
        map.set(id, Number.isFinite(qty) ? qty : null);
      });
    }
    __variantInventoryCacheByFormId.set(formId, map);
    return map;
  } catch (e) {
    console.error("Failed to parse variant inventory map:", e);
    __variantInventoryCacheByFormId.set(formId, null);
    return null;
  }
}

function updateInventoryDisplay({ variant, formId } = {}) {
  const formIdEscaped = formId ? __escapeAttributeValue(formId) : null;
  const pickers = formIdEscaped ? document.querySelectorAll(`variant-picker[form-id="${formIdEscaped}"]`) : document.querySelectorAll("variant-picker");

  // 対象バリアントがない場合は、該当picker内の表示だけ非表示にする
  if (!variant || variant.id == null) {
    pickers.forEach((picker) => {
      picker.querySelectorAll(".c-variant-picker-inventory-display").forEach((display) => {
        display.style.display = "none";
      });
    });
    return;
  }

  // まずはvariant自身のinventory_quantityを優先
  let inventoryCount = null;
  if (variant.inventory_quantity != null && variant.inventory_quantity !== "") {
    const parsed = parseInt(variant.inventory_quantity, 10);
    inventoryCount = Number.isFinite(parsed) ? parsed : null;
  }

  // フォールバック：Liquidで出したid→在庫数マップ
  if (inventoryCount == null) {
    const variantIdStr = String(variant.id);
    const map = __getVariantInventoryMap(formId);
    if (map && map.has(variantIdStr)) {
      inventoryCount = map.get(variantIdStr);
    }
  }

  const shouldShow = inventoryCount != null && inventoryCount >= 1 && inventoryCount <= 9;

  pickers.forEach((picker) => {
    picker.querySelectorAll(".c-variant-picker-inventory-display").forEach((display) => {
      const inventoryText = display.querySelector(".c-variant-picker-inventory-count");

      if (shouldShow && inventoryText) {
        inventoryText.textContent = `残り在庫数：${inventoryCount}個`;
        display.style.display = "block";
      } else {
        display.style.display = "none";
      }
    });
  });
}

// custom - 追加改修
// 変更内容：バリアント変更イベントのリスナーを初期化する関数を追加
// 仕様：
//   - ページ読み込み時に初期表示の在庫数を更新
//   - variant:changeイベントをリッスンしてバリアント変更時に在庫数を更新
//   - product:rerenderイベントもリッスンして動的にコンテンツが更新される場合にも対応
function initVariantInventoryDisplay() {
  // 初期表示時に在庫数を更新（variant-pickerごとにスコープして処理）
  document.querySelectorAll("variant-picker").forEach((picker) => {
    const formId = picker.getAttribute("form-id");
    const variantScript = picker.querySelector("script[data-variant]");
    if (!variantScript) return;

    try {
      const initialVariant = JSON.parse(variantScript.textContent || "{}");
      updateInventoryDisplay({ variant: initialVariant, formId });
    } catch (e) {
      console.error("Failed to parse initial variant:", e);
    }
  });

  // variant:changeイベントをリッスン
  document.addEventListener("variant:change", (event) => {
    if (event.detail && event.detail.variant) {
      let formId = event.detail.formId;

      // formIdがHTMLInputElementの場合（hidden input要素）、その親フォームのIDを取得
      if (formId && typeof formId === "object" && formId.nodeType === 1) {
        // DOM要素の場合
        if (formId.tagName === "INPUT" || formId.tagName === "FORM") {
          const form = formId.tagName === "FORM" ? formId : formId.closest("form");
          formId = form && form.id ? form.id : null;
        } else {
          formId = null;
        }
      }

      // formIdが文字列でない場合、イベントターゲットから取得を試みる
      if (!formId || typeof formId !== "string") {
        if (event.target) {
          // イベントターゲットがフォームの場合
          if (event.target.tagName === "FORM" && event.target.id) {
            formId = event.target.id;
          } else {
            // イベントターゲットの親要素からフォームを探す
            const form = event.target.closest("form");
            if (form && form.id) {
              formId = form.id;
            }
          }
        }
      }

      // まだformIdが見つからない場合、variant-pickerから取得を試みる（最も確実な方法）
      if (!formId || typeof formId !== "string") {
        // variant-picker要素を直接検索
        const pickers = document.querySelectorAll("variant-picker");
        if (pickers.length > 0) {
          // 最初に見つかったpickerのform-idを使用（通常は1つしかない）
          formId = pickers[0].getAttribute("form-id");
        }
      }

      updateInventoryDisplay({ variant: event.detail.variant, formId });
    }
  });

  // product:rerenderイベントもリッスン（動的にコンテンツが更新される場合）
  document.addEventListener("product:rerender", (event) => {
    const formId = event?.target?.id;
    // 少し遅延させてから在庫数を更新（DOM更新を待つ）
    setTimeout(() => {
      const formIdEscaped = formId ? __escapeAttributeValue(formId) : null;
      const pickers = formIdEscaped ? document.querySelectorAll(`variant-picker[form-id="${formIdEscaped}"]`) : document.querySelectorAll("variant-picker");

      pickers.forEach((picker) => {
        const pickerFormId = picker.getAttribute("form-id");
        const variantScript = picker.querySelector("script[data-variant]");
        if (!variantScript) return;

        try {
          const variant = JSON.parse(variantScript.textContent || "{}");
          // rerenderで内容が変わるのでキャッシュをクリアして再パースする
          if (pickerFormId) __variantInventoryCacheByFormId.delete(pickerFormId);
          updateInventoryDisplay({ variant, formId: pickerFormId });
        } catch (e) {
          console.error("Failed to parse variant after rerender:", e);
        }
      });
    }, 100);
  });
}

// ページ読み込み時に実行
document.addEventListener("DOMContentLoaded", () => {
  setAccordionBorders();
  initMapTabsWithGSAP(document);
  initMenuDrawerCloseHandler();
  // custom - 追加改修：バリアント在庫数表示の初期化を追加
  initVariantInventoryDisplay();
});

// Shopify テーマエディタでセクションが動的に読み込まれる場合に対応
document.addEventListener("shopify:section:load", (evt) => {
  if (evt.target && evt.target.querySelector(".c-map__container")) {
    initMapTabsWithGSAP(evt.target);
  }
  // メニュードロワーが動的に読み込まれた場合も対応
  if (evt.target && evt.target.querySelector("#menu-drawer")) {
    initMenuDrawerCloseHandler();
  }
  // アコーディオンが動的に読み込まれた場合も対応
  if (evt.target && evt.target.querySelector(".c-acordion")) {
    setAccordionBorders();
  }
  // custom - 追加改修：バリアントピッカーが動的に読み込まれた場合も対応
  if (evt.target && evt.target.querySelector("variant-picker")) {
    initVariantInventoryDisplay();
  }
});

// 374px未満のデバイスのレスポンシブ対応
!(function () {
  const viewport = document.querySelector('meta[name="viewport"]');

  function switchViewport() {
    const value = window.outerWidth > 374 ? "width=device-width,initial-scale=1" : "width=374";

    if (viewport.getAttribute("content") !== value) {
      viewport.setAttribute("content", value);
    }
  }

  addEventListener("resize", switchViewport, false);
  switchViewport();
})();
